
import { environment } from 'src/environments/environment';
import { InformacionFiltroMensajeriaDto } from '../data/InformacionFiltroMensajeriaDto';

export const monitoreoFeatureKey = environment.keyMonitoreo;

export interface MonitoreoState {
  hora?: string;
  contador?: number;
}

export const initialState: MonitoreoState = {
  hora: '',
  contador: 0,
};


